import React from 'react';
import { FieldControlProps } from '../FieldRenderer';
import OptionButtons from './OptionButtons';

// Any number of options can be picked; clicking a picked one unpicks it.
const MultiChoiceInput: React.FC<FieldControlProps> = ({ field, value, onChange }) => {
  const selected = Array.isArray(value) ? value : [];

  return (
    <OptionButtons
      label={field.field_label}
      options={field.options ?? []}
      isSelected={(v) => selected.includes(v)}
      onPick={(v) => onChange(selected.includes(v) ? selected.filter((s) => s !== v) : [...selected, v])}
    />
  );
};

export default MultiChoiceInput;
